// extracted by mini-css-extract-plugin
export default {"name-cell":"_name-cell_m8IPW1","name-cell-not-sticky":"_name-cell-not-sticky_nJmDto"};